var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescriptionRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.914 23.5l2.793-2.793a1 1 0 10-1.415-1.415L21.5 22.087l-5.144-5.145A6.5 6.5 0 0015.5 4H9a1 1 0 00-1 1v19a1 1 0 102 0v-7h3.586l6.5 6.5-2.793 2.793a1 1 0 101.415 1.415l2.792-2.794 2.793 2.793a1 1 0 001.415-1.415L22.913 23.5zM10 6h5.5a4.5 4.5 0 110 9H10V6z"
  })));
}
export default SvgPrescriptionRegular;